import RedirectToCustomer from './RedirectToCustomer';

export default RedirectToCustomer;
